import React, { FC } from "react";

interface ErrorsProps {
  errors: string[];
}

export const Errors: FC<ErrorsProps> = ({ errors }) => {
  if (errors.length == 0) return null;

  return (
    <>
      <p className="error-message"/>
      {errors.map((e) => (
        <span key={e} dangerouslySetInnerHTML={{ __html: e }} />
      ))}
    </>
  );
};
